import { useEffect } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";

/** Ajusta el viewport al array de puntos [{lat,lng}] */
export function AutoFitBounds({ points, padding = [40, 40] }) {
  const map = useMap();
  useEffect(() => {
    if (!Array.isArray(points) || points.length === 0) return;
    const bounds = L.latLngBounds(points.map((p) => [p.lat, p.lng]));
    map.fitBounds(bounds, { padding });
  }, [points, map, padding]);
  return null;
}
